define('modules/form/form_item_collection',[
  'backbone',
  './form_item_model'
], function (Backbone, ItemModel) {
  'use strict';
  var FormItemCollection = Backbone.Collection.extend({
    model: ItemModel
  });

  return FormItemCollection;
});

